export enum NotificationFrequencyEnum {
    OneDay = 1,
    TwoDays = 2,
    FiveDays = 3,
    SevenDays = 4,
    TenDays = 5,
    TwelveDays = 6,
    FifteenDays = 7,
}
